import { MatchEventClientModel } from '@sport1/types/sportData'
import { SummaryEventRowProps } from '@sport1/news-styleguide/Types'
import getEventIconType from '@/components/LivetickerSummary/utils/getEventIconType'
import getPlayerName from '@/utils/sportsData/getPlayerName'

const getSummaryEventRow = (
    matchEvent: MatchEventClientModel
): SummaryEventRowProps | undefined => {
    const { away, matchEventMinute, player, subOnPlayer, eventType, subType, period } = matchEvent
    const timeLabel = period !== 'SHOOTOUT' ? matchEventMinute || '' : ''
    const competitor = player || subOnPlayer
    const ownGoal = subType === 'OWN' ? ' (ET)' : ''
    const competitorName = competitor ? getPlayerName(competitor, 'lastname') + ownGoal : undefined
    if (away && competitorName) {
        return {
            timeLabel,
            awayCompetitor: competitorName,
            awayIconType: getEventIconType({ eventType, subType }),
        }
    } else if (!away && competitor) {
        return {
            timeLabel,
            homeCompetitor: competitorName,
            homeIconType: getEventIconType({ eventType, subType }),
        }
    }
}

export default getSummaryEventRow
